import { getRecommend } from "@shared/apis/cprod";
import { wrapGatewaySuperagent } from "@shared/apis/gw-helper";

const recommendByCityId = Object.create(null);

export function getRecommendByCityId(cityId) {
  if (cityId in recommendByCityId) return Promise.resolve(recommendByCityId[cityId]);
  return wrapGatewaySuperagent(getRecommend({ cityId })).then(res => res.body.data);
}

require("./index.less");